import { useCallback, useState, useEffect } from "react";
import { useWeb3React } from "@web3-react/core";
import { getLibraryForSign } from "../utils/web3React";
import useLibrary from "./useLibrary";
import { ethers } from "ethers";
import useWeb3 from "../hooks/useWeb3";
import { connectorsByName } from "../utils/web3React";

const useSignature = (wab) => {
  const web3 = useWeb3();
  const { account } = useWeb3React();

  let library = null;
  const connectorId =
    typeof window !== "undefined"
      ? window.localStorage.getItem("connectorId")
      : null;
  if (connectorId === "injected" && account) {
    library = getLibraryForSign(web3?.givenProvider);
  } else {
    if (connectorsByName.walletconnect.provider) {
      library = getLibraryForSign(connectorsByName.walletconnect.provider);
    }
  }
  if (connectorsByName?.coinbase?.provider) {
    library = getLibraryForSign(connectorsByName?.coinbase?.provider);
  }
  const sign = useCallback(async () => {
    const connectorId = window.localStorage.getItem("connectorId");
    if (connectorId === "injected" && account) {
      library = getLibraryForSign(web3?.givenProvider);
    } else {
      if (connectorsByName?.walletconnect?.provider) {
        library = getLibraryForSign(connectorsByName?.walletconnect?.provider);
      } else if (connectorsByName?.coinbase?.provider) {
        library = getLibraryForSign(connectorsByName?.coinbase?.provider);
      }
    }
    if (library && account) {
      try {
        let signature = await library.send(
          "personal_sign",
          // [ethers.hexlify(ethers.toUtf8Bytes("Sign this message to verify ownership of the wallet." + account)), account]
          [ethers.hexlify(ethers.toUtf8Bytes(account?.toLowerCase())), account]
        );
        return signature;
      } catch (error) {
        throw error;
      }
    }
  }, [account, web3, connectorId]);

  return { userSign: sign, userLibrary: library };
};

export default useSignature;
